export { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
	faRobot,
	faComment,
	faCommentAlt,
	faCubes,
	faCog,
	faCheck,
	faCode,
	faTrash,
	faAngleDown,
	faArrowRight,
	faChevronRight,
	faUser,
	faCube,
	faFile,
	faChartArea,
	faChartBar,
	faChartLine,
	faExclamationCircle,
	faPercent,
	faCalendarAlt,
	faUserFriends,
	faBan,
	faAngleUp,
	faLevelUpAlt,
	faCopy
} from '@fortawesome/free-solid-svg-icons';

import {
	faFile as farFile,
	faComment as farComment,
	faClock as farClock
} from '@fortawesome/free-regular-svg-icons';

library.add(faRobot);
library.add(faComment);
library.add(faCommentAlt);
library.add(faCubes);
library.add(faCog);
library.add(faCheck);
library.add(faCode);
library.add(faTrash);
library.add(faAngleDown);
library.add(faAngleUp);
library.add(faArrowRight);
library.add(faChevronRight);
library.add(faUser);
library.add(faCube);
library.add(faFile);
library.add(farFile);
library.add(farComment);
library.add(faChartArea);
library.add(faChartBar);
library.add(faChartLine);
library.add(faExclamationCircle);
library.add(faPercent);
library.add(faCalendarAlt);
library.add(faUserFriends);
library.add(faBan);
library.add(faLevelUpAlt);
library.add(farClock);
library.add(faCopy);
